// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/page-header.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "cartero-mail-app")
// Destination      : packages/fleet/ui/src/page-header.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo cartero-mail-app
//     node fleet/fleet.ts check --repo cartero-mail-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import type { JSX } from "solid-js";
import { Link } from "@tanstack/solid-router";
import { ArrowLeft } from "@fleet/icons";
import { cn } from "@cartero/shared";

interface PageHeaderProps {
  title: string;
  description?: string;
  backTo?: string;
  icon?: (props: { class?: string }) => JSX.Element;
  class?: string;
}

export function PageHeader(props: PageHeaderProps) {
  return (
    <div class={cn("flex items-center gap-4 select-none", props.class)}>
      {props.backTo && (
        <Link
          to={props.backTo}
          class="p-2 rounded-full hover:bg-secondary/20 transition-colors border border-border/10 cursor-pointer shrink-0"
        >
          <ArrowLeft class="h-5 w-5 text-foreground/80" />
        </Link>
      )}
      <div>
        <h1 class="text-3xl font-extrabold tracking-tight flex items-center gap-2">
          {props.icon && <props.icon class="h-8 w-8 text-primary shrink-0" />}
          {props.title}
        </h1>
        {props.description && <p class="text-sm text-muted-foreground mt-1">{props.description}</p>}
      </div>
    </div>
  );
}
